import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { cn } from "@/lib/utils";
import { Sparkles } from "lucide-react";
import { useState } from "react";

type Step3AgentConfirmationProps = {
  systemPrompt: string;
  onSystemPromptChange: (prompt: string) => void;
};

const Step3AgentConfirmation = ({
  systemPrompt,
  onSystemPromptChange,
}: Step3AgentConfirmationProps) => {
  const [isEditingPrompt, setIsEditingPrompt] = useState(false);
  const [editedPrompt, setEditedPrompt] = useState(systemPrompt);

  const handleEditPrompt = () => {
    setEditedPrompt(systemPrompt);
    setIsEditingPrompt(true);
  };

  const handleCancelEditPrompt = () => {
    setIsEditingPrompt(false);
    setEditedPrompt(systemPrompt);
  };

  const handleSavePrompt = () => {
    onSystemPromptChange(editedPrompt);
    setIsEditingPrompt(false);
  };

  return (
    <div className="flex flex-col gap-6">
      <p className="text-lg font-semibold mb-4">
        Confirmacion - Instrucciones del Agente
      </p>

      <div className="w-[70%]">
        <div className="flex justify-between items-center mb-4">
          <div className="flex items-center gap-2">
            <Sparkles className="size-5 text-purple-500" />
            <p className="text-base font-semibold">
              Instrucciones del Agente
            </p>
          </div>
          {!isEditingPrompt ? (
            <Button size="sm" onClick={handleEditPrompt}>
              Editar
            </Button>
          ) : (
            <div className="flex items-center gap-2">
              <Button size="sm" className="bg-green-600 hover:bg-green-700" onClick={handleSavePrompt}>
                Guardar
              </Button>
              <Button size="sm" variant="outline" onClick={handleCancelEditPrompt}>
                Cancelar
              </Button>
            </div>
          )}
        </div>

        <Textarea
          value={isEditingPrompt ? editedPrompt : systemPrompt}
          onChange={(e) => setEditedPrompt(e.target.value)}
          readOnly={!isEditingPrompt}
          className={cn(
            "h-[70vh] resize-y border text-sm font-mono p-4 overflow-y-auto",
            isEditingPrompt
              ? "bg-white border-blue-300 focus:border-blue-500 focus:ring-blue-500"
              : "bg-gray-50 border-gray-200"
          )}
        />
      </div>
    </div>
  );
};

export default Step3AgentConfirmation;
